"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCard = exports.EntityCardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var types_1 = require("@shapeable/types");
var theme_1 = require("@shapeable/theme");
var card_1 = require("../elements/card");
var content_1 = require("../elements/content");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_entities_1 = require("../../hooks/use-entities");
var use_app_screen_1 = require("../../hooks/use-app-screen");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var entity_type_icon_label_1 = require("./entity-type-icon-label");
var lodash_1 = require("lodash");
var entity_count_label_1 = require("./entity-count-label");
var entity_image_1 = require("./entity-image");
var entity_cell_header_1 = require("./entity-cell-header");
var entity_list_1 = require("./entity-list");
exports.EntityCardDefaultProps = {};
// -------- Styles -------->
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "], ["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG())
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('link-hover'))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var CountLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var SitesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.UNIT(2), theme_1.theme.COLOR('dark'))
});
var FollowControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n    padding-left: 1px;\n    padding-bottom: ", ";\n  "], ["\n    color: ", ";\n    padding-left: 1px;\n    padding-bottom: ", ";\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.UNIT(1))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme_1.theme.H_DOT_BG())
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Image: (0, styled_components_1.default)(entity_image_1.EntityImage)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Title: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Footer: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  Label: (0, styled_components_1.default)(entity_type_icon_label_1.EntityTypeIconLabel)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityFieldCountLabel)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), CountLabelStyles),
  Sites: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), SitesStyles),
  TaxonomyList: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), SitesStyles)
};
var EntityCard = function (props) {
  var _a;
  var className = props.className,
    entity = props.entity,
    hspace = props.hspace,
    onClick = props.onClick,
    entityTypeName = props.entityTypeName,
    image = props.image,
    showFollowControls = props.showFollowControls;
  var entities = (0, use_entities_1.useEntities)();
  var entityDict = entity;
  var definition = entityTypeName ? (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName) : (0, use_entity_definition_1.useEntityDefinition)(entity, true);
  var description = entity.description || ((_a = entity.openGraph) === null || _a === void 0 ? void 0 : _a.description);
  var details = definition.details;
  var children = (0, use_app_screen_1.useAppScreen)().detailsChildren;
  var aspectRatio = {
    base: 16 / 9,
    landscape: 21 / 9,
    tablet: 16 / 9
  };
  /* infer count labels based on children */
  var countLabels = children.map(function (child) {
    var entityTypeName = child.entityTypeName,
      junctionEntityTypeName = child.junctionEntityTypeName,
      type = child.type,
      fieldName = child.fieldName,
      showCountLabel = child.showCountLabel;
    var childEntityDefinition = entities[junctionEntityTypeName || entityTypeName];
    var value = entityDict[childEntityDefinition && (0, lodash_1.camelCase)(childEntityDefinition.leadingPluralTypeName)];
    var etn = childEntityDefinition ? childEntityDefinition.name : null;
    return showCountLabel && etn && value && !!value.length && React.createElement(My.CountLabel, {
      key: "count-".concat(etn, "-").concat(fieldName),
      entityTypeName: etn,
      value: value
    });
  });
  var _b = entity.sites,
    sites = _b === void 0 ? [] : _b;
  var hasSites = !!sites.length;
  var descriptionText = description && ((0, types_1.isContentNode)(description) ? description.plainTruncated || description.plain || description.text || description.textTruncated : description);
  return React.createElement(My.Card, __assign({}, props, {
    hspace: hspace,
    space: 4,
    titleMargin: "none",
    to: !onClick && definition.to(entity.slug),
    className: className,
    image: image || React.createElement(My.Image, {
      aspectRatio: aspectRatio,
      entity: entity
    })
  }), React.createElement(My.Header, {
    entity: entity
  }), React.createElement(My.Title, null, entity.name), hasSites && React.createElement(My.Sites, {
    variant: 'card',
    items: sites
  }), (0, types_1.isEntityWithChallenges)(entity) && !!entity.challenges.length && React.createElement(My.TaxonomyList, {
    items: entity.challenges,
    variant: "card"
  }), (0, types_1.isEntityWithKeyIssues)(entity) && !!entity.keyIssues.length && React.createElement(My.TaxonomyList, {
    items: entity.keyIssues,
    variant: "card"
  }), (0, types_1.isEntityWithTrends)(entity) && !!entity.trends.length && React.createElement(My.TaxonomyList, {
    items: entity.trends,
    variant: "card"
  }), (0, types_1.isEntityWithTopics)(entity) && !!entity.topics.length && React.createElement(My.TaxonomyList, {
    items: entity.topics,
    variant: "card"
  }), (0, types_1.isEntityWithSubTopics)(entity) && !!entity.subTopics.length && React.createElement(My.TaxonomyList, {
    items: entity.subTopics,
    variant: "card"
  }), (0, types_1.isEntityWithSdgs)(entity) && !!entity.sdgs.length && React.createElement(My.TaxonomyList, {
    items: entity.sdgs,
    variant: "card"
  }), countLabels, props.children, descriptionText && React.createElement(My.Content, {
    tiny: true,
    html: descriptionText
  }), props.afterDescription);
};
exports.EntityCard = EntityCard;
exports.EntityCard.defaultProps = exports.EntityCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20;